





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CplusCriteria,
  JBICriterion,
  JBICriterionTypeBoolean,
  JBICriterionTypeCheckboxes,
  JBICriterionTypeRange,
} from '@/store/modules/projects/types/projects.types';
import { CRITERION_TYPE } from '@/jbi-shared/types/criterions.types';
import { highlightText } from '@/utils/highlight.util';

@Component({})
export default class CriteriaDetailsTemplate extends Vue {
  @Prop() criteria!: CplusCriteria | JBICriterion;
  @Prop({ type: String, default: '' }) activeSearchTerm!: string;

  get highlightedTitle(): string {
    return highlightText(this.criteria.title, this.activeSearchTerm);
  }

  get showCustomTag() {
    const criteria: CplusCriteria = this.criteria as CplusCriteria;
    if (
      (criteria.document !== undefined && criteria.document.id === '') ||
      (criteria.isCustom && criteria.isCustom === true) ||
      (criteria.isChanged && criteria.isChanged === true)
    ) {
      return true;
    }

    return false;
  }

  getCriteriaOptions(criteria: CplusCriteria | JBICriterion): string[] {
    let options: string[] = [];
    switch (criteria.type) {
      case CRITERION_TYPE.BOOLEAN:
        options = (criteria as JBICriterionTypeBoolean).booleanOptions;
        break;
      case CRITERION_TYPE.RANGE:
        options = (criteria as JBICriterionTypeRange).range;
        break;
      case CRITERION_TYPE.CHECKBOXES:
        options = (criteria as JBICriterionTypeCheckboxes).checkboxesOptions;
        break;
      default:
        break;
    }

    return options;
  }
}
